import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/superadmin/map-scanner")({
  // Component moved to superadmin.map-scanner.lazy.tsx for code splitting
});
